import { css } from '@emotion/css';

import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';
import { Rubric } from '@/types/schema';

const w32 = css`
  min-width: 3.2rem;
`;

const rounded6 = css`
  border-radius: 0.6rem;
`;

const RubricDetails = ({ rubric }: { rubric: Rubric }) => {
  return (
    <Stack>
      <Stack
        alignItems="center"
        className={cn(w32, rounded6, 'mt-2 h-32 bg-bg-tertiary me-16')}
        justifyContent="center">
        <Typography color="text-text-secondary" variant="body-short-02">
          {rubric.score ?? rubric.maxScore}
        </Typography>
      </Stack>
      <Stack direction="col">
        <Typography color="text-text-primary" variant="body-short-03">
          {rubric.label}
        </Typography>
        <Typography
          className="mt-2 whitespace-pre-line"
          color="text-text-secondary"
          variant="body-short-03">
          {rubric.description}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default RubricDetails;
